'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'plane-lock';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e558';
var svgPathData = 'M224 32c0-35.3 28.7-64 64-64s64 28.7 64 64l0 105 84.5 77.5c-7.5 7.7-14 16.3-19.4 25.6l-65.1-59.7 0 144.1 39.1 13c-7.1 8.3-12.8 17.8-16.8 28.1l-22.3-7.4 0 58.1 16 12.8 0 41-42-33.6c-3.8-3-6-7.6-6-12.5l0-392c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 392c0 4.9-2.2 9.5-6 12.5l-74 59.2 0 19.8 108.1-27c2.5-.6 5.2-.6 7.8 0l76.8 19.2c1.6 13 5.8 25.1 12 36l-92.7-23.2-124.1 31c-4.8 1.2-9.8 .1-13.7-2.9S144 540.9 144 536l0-48c0-4.9 2.2-9.5 6-12.5l74-59.2 0-58.1-170.9 57c-4.9 1.6-10.2 .8-14.4-2.2S32 405.1 32 400l0-80c0-4.5 1.9-8.8 5.2-11.8L224 137 224 32zM64 327l0 50.8 160-53.3 0-144.1-160 146.7zm384 25.1l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96c0-20.9 13.4-38.7 32-45.3l0-2.6zm0 47.9l0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-96c0-8.2-6.2-15-14.3-15.9l-131.5 0c-8 .9-14.3 7.7-14.3 15.9zm128-95.9c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 47.9 96 0 0-47.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlaneLock = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;